import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import ShopFloor from "@/pages/ShopFloor";
import { ProductsPage, MachinesPage, MouldsPage, RawMaterialsPage, WarehousesPage, SuppliersPage, CustomersPage, UnitsPage, BOMPage, UsersPage, AuditPage } from "@/pages/Masters";
import { ProductionOrdersPage, ProductionEntryPage, DowntimePage, QCPage } from "@/pages/Production";
import { GRNPage, FGInventoryPage, DispatchPage, TraceabilityPage } from "@/pages/Inventory";
import { OrderTrackerPage, SalesOrdersPage } from "@/pages/OrderTracker";
import DataImportPage from "@/pages/DataImport";
import RMPlanningPage from "@/pages/RMPlanning";
import { RMStockPage, RMIssuePage, RMReturnPage } from "@/pages/RMStores";
import SchedulePage from "@/pages/Schedule";
import { PurchaseOrdersPage, InvoicesPage } from "@/pages/Billing";
import { AgedReceivablesPage, ZohoSyncPage } from "@/pages/Finance";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/order-tracker" element={<OrderTrackerPage />} />
        <Route path="/sales-orders" element={<SalesOrdersPage />} />
        <Route path="/shop-floor" element={<ShopFloor />} />
        <Route path="/production-orders" element={<ProductionOrdersPage />} />
        <Route path="/rm-planning" element={<RMPlanningPage />} />
        <Route path="/rm-stock" element={<RMStockPage />} />
        <Route path="/rm-issues" element={<RMIssuePage />} />
        <Route path="/rm-returns" element={<RMReturnPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/production-entry" element={<ProductionEntryPage />} />
        <Route path="/downtime" element={<DowntimePage />} />
        <Route path="/qc" element={<QCPage />} />
        <Route path="/traceability" element={<TraceabilityPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/bom" element={<BOMPage />} />
        <Route path="/machines" element={<MachinesPage />} />
        <Route path="/moulds" element={<MouldsPage />} />
        <Route path="/raw-materials" element={<RawMaterialsPage />} />
        <Route path="/warehouses" element={<WarehousesPage />} />
        <Route path="/suppliers" element={<SuppliersPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/units" element={<UnitsPage />} />
        <Route path="/grn" element={<GRNPage />} />
        <Route path="/fg-inventory" element={<FGInventoryPage />} />
        <Route path="/dispatch" element={<DispatchPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/data-import" element={<DataImportPage />} />
        <Route path="/purchase-orders-supplier" element={<PurchaseOrdersPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/aged-receivables" element={<AgedReceivablesPage />} />
        <Route path="/zoho-sync" element={<ZohoSyncPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
